import { isLoadingReducer } from 'store/reducerUtils';
import { setDealStatus } from 'modules/settings/submodules/clients/deals/components/UpdateStatusSelect/store/actions';

export const isDealStatusUpdating = isLoadingReducer(setDealStatus);
